import React, { Component } from "react";
import { Helmet } from "react-helmet";

class Contact extends Component {

    render() {

        let pageTitle = this.props.lang == 'en' ? "Contact" : "Επικοινωνια";
        let gkapi = this.props.lang == 'en' ? 'Georgia M. Kapitsaki (gkapi_AT_.ucy.ac.cy)' : 'Γεωργία Μ. Καπιτσάκη (gkapi_AT_.ucy.ac.cy)';
        let gchara = this.props.lang == 'en' ? 'Georgia Charalambous (gchara04_AT_.ucy.ac.cy)' : 'Γεωργία Χαραλάμπους (gchara04_AT_.ucy.ac.cy)';
        let feedback = this.props.lang == 'en' ? 'Feedback' : 'Ανατροφοδoτηση';
        let feedbacktext = this.props.lang == 'en' ? 'Please give us your valuable feedback for PrivacySaferII by completing a questionnaire.You can find the link to the questionnaire '
            : 'Παρακαλώ δώστε μας τα πολύτιμα σχόλιά σας για το PrivacySaferII συμπληρώνοντας ένα ερωτηματολόγιο. Μπορείτε να βρείτε το σύνδεσμο για το ερωτηματολόγιο ';
        let feedbacktextHere = this.props.lang == 'en' ? "here" : "εδώ"

        return (
            <section className="page-section" id="contact">
                <Helmet>
                    <meta charset="utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                    <meta name="description" content="" />
                    <meta name="author" content="" />
                    <title>PrivacySaferIII</title>

                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
                    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
                    <script src="https://use.fontawesome.com/releases/v5.12.1/js/all.js" crossorigin="anonymous"></script>


                    <link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css" />
                    <link href="https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic" rel="stylesheet"
                        type="text/css" />
                </Helmet>
                <div className="container">

                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0"><label className="lang"
                        key="contactTitle">{pageTitle}</label></h2>

                    <div className="divider-custom">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon"><i className="fas fa-envelope"></i></div>
                        <div className="divider-custom-line"></div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8 mx-auto">
                            <div className="form-group">
                                <h4 className="floating-label-form-group text-uppercase mb-4">Email</h4>
                                <label className="lang" key="gkapi">{gkapi}</label>
                                <br />
                                <label className="lang" key="gchara">{gchara}</label>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8 mx-auto">
                            <div className="form-group">
                                <h4 className="floating-label-form-group text-uppercase mb-4">{feedback}</h4>

                                <label className="lang feedbacklabel" key="feedbackTextPartOne">
                                    {feedbacktext} </label> <a
                                        href="https://docs.google.com/forms/d/e/1FAIpQLSc_amY8vBCBdLlDZw60lWDhrcK8DWIioB_6dTowyfnlUIkJXg/viewform"
                                        target="_blank"><span className="lang" key="feedbackTextPartTwo">{feedbacktextHere}.</span></a>


                            </div>
                        </div>
                    </div>

                </div>
            </section>
        );
    }
}

export default Contact;